import { useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";

const Recognition = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

export const VoiceButton = ({ onTranscript, disabled }) => {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  if (!Recognition) return null;

  const toggle = () => {
    if (listening) {
      recRef.current?.stop();
      return;
    }
    const rec = new Recognition();
    rec.lang = navigator.language || "en-US";
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onresult = (e) => {
      const text = e.results?.[0]?.[0]?.transcript?.trim();
      if (text) onTranscript(text);
    };
    rec.onerror = (e) => {
      if (e.error !== "aborted" && e.error !== "no-speech") toast.error("Microphone unavailable — check permissions");
    };
    rec.onend = () => setListening(false);
    recRef.current = rec;
    setListening(true);
    rec.start();
    toast("Listening… say something like \"40 dollars for groceries today\"");
  };

  return (
    <Button type="button" variant={listening ? "destructive" : "outline"} onClick={toggle} disabled={disabled}
      className={`h-11 w-11 rounded-xl shrink-0 p-0 ${listening ? "animate-pulse" : ""}`}
      title={listening ? "Stop listening" : "Speak your expense"} data-testid="voice-add-btn">
      {listening ? <MicOff className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
    </Button>
  );
};
